// extracted by mini-css-extract-plugin
module.exports = {"boxSearch":"_1S1XvdkVtf9hTOgxmBPhIf","boxInput":"_3C2IOBbl6eCklXByAAKVtL","inputSearch":"_2wNjsy1lbxdS-nrqZr9V_o"};